var E=(T=>(T.GET="GET",T.POST="POST",T.PUT="PUT",T.DELETE="DELETE",T.PATCH="PATCH",T))(E||{});export{E as a};
